import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import { requestFailCallback } from '../../utils/serviceUtil.js';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import 'tslib';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import { requestSuccessCallbackV3, responseSuccessCallbackV3, responseFailCallbackV3 } from '../../utils/serviceUtilv3.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import axios from 'axios';

const baseDiscoverService = axios.create({
    baseURL: process.env.PEEK_APP_DISCOVER_API_URL,
});
baseDiscoverService.defaults.headers.common["Content-Type"] = "application/json";
baseDiscoverService.defaults.headers.common["x-peek-api-version"] = process.env.PEEK_APP_API_VERSION;
// Add a request interceptor
baseDiscoverService.interceptors.request.use(requestSuccessCallbackV3, requestFailCallback);
// Add a response interceptor
baseDiscoverService.interceptors.response.use(responseSuccessCallbackV3, responseFailCallbackV3);

export { baseDiscoverService as default };
